import React, { useCallback, memo } from 'react';
import { Select, Checkbox } from '@leasequery/lq.react-component-library';
import { SelectOption } from '@leasequery/lq.react-component-library/dist/models';
import { REPORT_CURRENCY_SELECT_OPTIONS } from '../../../constants';
import { ReportCurrency, ClientCustomCalendarModel } from '../../../models';
import * as Styled from './styled';
import { ReportTypeSetting } from '../../../models/reportTypeSetting';
import { Icon } from '../../../components';
import { CurrencySelectorWrapper } from '../../../components';

interface ReportSettingSubleaseProps {
  onChange: (updatedValue: ReportSettingSubleaseState) => void;
  reportSettingState: ReportSettingSubleaseState;
  customCalendarSettings?: ClientCustomCalendarModel;
  reportTypeSetting: ReportTypeSetting;
  isAllowPIT: boolean;
}

export interface ReportSettingSubleaseState {
  selectedCurrency: SelectOption<ReportCurrency>;
  startDate: string;
  endDate: string;
  isBasedRentOnly: boolean;
  isValid: boolean;
}

function ReportSettingSublease({
  onChange,
  reportSettingState,
}: ReportSettingSubleaseProps): JSX.Element {
  return (
    <>
      <CurrencySelectorWrapper>
        <Styled.DropdownBar>
          <div>
            <Icon name="currency" />
          </div>
          <Select
            placeholder="Local currency"
            label="Currency"
            name="currency"
            options={REPORT_CURRENCY_SELECT_OPTIONS}
            onChange={useCallback(
              (option: SelectOption<ReportCurrency>): void => {
                onChange({
                  ...reportSettingState,
                  selectedCurrency: option,
                });
              },
              [onChange, reportSettingState],
            )}
            value={reportSettingState.selectedCurrency}
          />
        </Styled.DropdownBar>
      </CurrencySelectorWrapper>
      <Styled.Line />
      <Styled.Spacer />
      <Styled.ReportSettingRow>
        <div>
          <Icon name="gear" />
        </div>
        <div className="label">
          Run With
          <div className="item">
            <Checkbox
              name="isBaseRentOnly"
              label="Base Rent Only"
              onChange={useCallback(
                (event): void => {
                  onChange({
                    ...reportSettingState,
                    isBasedRentOnly: event.currentTarget.checked,
                  });
                },
                [onChange, reportSettingState],
              )}
              checked={reportSettingState.isBasedRentOnly}
            />
          </div>
        </div>
        <p />
      </Styled.ReportSettingRow>
    </>
  );
}

export default memo(ReportSettingSublease);
